import { render, staticRenderFns } from "./point-icon-picker.vue?vue&type=template&id=e21df038"
import script from "./point-icon-picker.vue?vue&type=script&lang=js"
export * from "./point-icon-picker.vue?vue&type=script&lang=js"
import style0 from "./point-icon-picker.vue?vue&type=style&index=0&id=e21df038&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports